import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import jwt_decode from 'jwt-decode';

const token = sessionStorage.getItem('ictp-token') || "";
let claims = null;

if (token) {
  claims = jwt_decode(token);
}

export default {
  state: {
    token,
    exp: claims ? claims.exp : null,
    timeout: null,
    claims,
  },
  actions,
  getters,
  mutations,
};
